'use client';

import type { BoxProps } from '@mui/material/Box';
import type { CSSObject } from '@mui/material/styles';

import { useTolgee } from '@tolgee/react';
import { forwardRef } from 'react';

import { LogoZh } from '@/components-v2/icons/LogoZh';
import { LogoEn } from '@/components-v2/icons/logoEn';
import { RouterLink } from '@/routes/components';
import Box from '@mui/material/Box';

// ----------------------------------------------------------------------

export const logoClasses = {
  root: 'mnl__logo__root',
};

// ----------------------------------------------------------------------

export type LogoProps = BoxProps & {
  disableLink?: boolean;
};

export const Logo = forwardRef<HTMLDivElement, LogoProps>(({ disableLink = false, sx, className, ...other }, ref) => {
  const tolgee = useTolgee();
  const currentLanguage = tolgee.getLanguage();

  const baseStyles = {
    flexShrink: 0,
    color: 'inherit',
    display: 'inline-flex',
    alignItems: 'center',
    height: 32,
    ...sx,
  } as CSSObject;

  return (
    <Box
      ref={ref}
      component={RouterLink}
      href="/workflows/"
      title="workflows"
      className={logoClasses.root.concat(className ? ` ${className}` : '')}
      aria-label="CrowdComputed Logo"
      sx={{
        ...baseStyles,
        ...(disableLink && { pointerEvents: 'none' }),
      }}
      {...other}
    >
      <Box
        component={currentLanguage === 'zh' ? LogoZh : LogoEn}
        sx={{ height: '100%', width: 'auto', objectFit: 'contain' }}
      />
    </Box>
  );
});
